/**
* Determines if a given hex color is light or dark to adjust text color for contrast.
                                                                            * @param hexColor The hex color string (e.g., "#ffffff" or "#000000")
* @returns 'text-white' or 'text-gray-800'
*/
export const getContrastTextColor = (hexColor?: string): string => {
    if (!hexColor) {
        return 'text-gray-800'
    }

    const hex = hexColor.replace('#', '')
    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)

    // Calculate relative luminance
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000

    return yiq >= 128 ? '#333' : '#fff'
}

/**
* Returns a darker version of the given hex color.
* @param hexColor The hex color string (e.g., "#ffffff" or "#000000")
* @param factor The darkening factor (0-1), where 0 means no change and 1 means black. Default is 0.2
* @returns The darkened hex color string
*/
export const getDarkerColor = (hexColor: string, factor: number = 0.2): string => {
    if (!hexColor) {
        return '#000000'
    }

    const hex = hexColor.replace('#', '')
    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)

    // Darken each channel
    const darkR = Math.round(r * (1 - factor))
    const darkG = Math.round(g * (1 - factor))
    const darkB = Math.round(b * (1 - factor))

    return `#${darkR.toString(16).padStart(2, '0')}${darkG.toString(16).padStart(2, '0')}${darkB.toString(16).padStart(2, '0')}`
}
